import * as React from 'react';

import AdminClockReview from './AdminClockReview';
import AdminTools from './AdminTools';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import MyClockRequests from './MyClockRequests';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { clearToken, getUserEmail, isAdmin, refreshRole } from '../lib/authentication';

// The signed in user's profile: the clocks they have asked to add and where each
// stands. Admins get two more tabs: reviewing requests, and the data export / roles.
export default function ProfileDialog(props) {
    const { open, onClose, onAddClock, onLogout, reloadKey } = props;
    const [tab, setTab] = React.useState(0);
    const [, setRoleChecked] = React.useState(0); // re-render once the role has been re-checked
    const admin = isAdmin();

    // always start on the user's own clocks, and re-check the role: it's cached at login, so
    // someone made an admin since then would otherwise not see the admin tabs until they log in again
    React.useEffect(() => {
        if (!open) return;
        setTab(0);
        refreshRole().then((role) => { if (role) setRoleChecked((n) => n + 1); });
    }, [open]);

    const handleLogout = () => {
        clearToken();
        if (onLogout) onLogout();
        else onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" scroll="paper">
            <DialogTitle className="dialogTitle">
                <Box>
                    Profile
                    <Typography variant="subtitle1" component="div" sx={{ fontWeight: 600, wordBreak: 'break-all' }}>
                        {getUserEmail()} {admin ? <Chip size="small" label="Admin" color="primary" sx={{ ml: 0.5 }} /> : null}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Button size="small" variant="outlined" color="error" startIcon={<LogoutIcon />} onClick={handleLogout}>
                        Log out
                    </Button>
                    <IconButton onClick={onClose} aria-label="Close dialog">
                        <CloseIcon style={{ color: '#ff334b' }} />
                    </IconButton>
                </Box>
            </DialogTitle>
            {admin ? (
                <Tabs value={tab} onChange={(event, value) => setTab(value)} variant="fullWidth">
                    <Tab label="My clocks" />
                    <Tab label="Review requests" />
                    <Tab label="Data & users" />
                </Tabs>
            ) : null}
            <DialogContent dividers>
                {tab === 0 ? <MyClockRequests reloadKey={reloadKey} onAddClock={onAddClock} /> : null}
                {admin && tab === 1 ? <AdminClockReview /> : null}
                {admin && tab === 2 ? <AdminTools /> : null}
            </DialogContent>
        </Dialog>
    );
}
